var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.getClass},[_vm._t("default"),_vm._l((_vm.getActiveRules),function(rule,i){return _c('div',{key:'rule-' + i,staticClass:"ui basic red pointing prompt label transition scale in",staticStyle:{"animation-duration":"200ms"},attrs:{"id":_vm.id}},[_vm._v(" "+_vm._s(rule.msg)+" ")])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }